import { Injectable } from "@angular/core";
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate } from "@angular/router";
import {Observable, map, switchMap, of, tap} from "rxjs";
import { AuthorizationServiceProvider } from "./authorization-service.provider";
import {UserRole} from "./api/authorization.api";
import { LogsService } from "../../utils/services/logs.service";

@Injectable({
  providedIn: 'root'
})
export class RoleGuardService implements CanActivate {

  constructor(private authServiceProv: AuthorizationServiceProvider,
    private router: Router,
    private logger: LogsService) {}

canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const roles = route.data['roles'] as Array<UserRole>;
    this.logger.log(`[RoleGuard] start url=${state.url} expectedRoles=${JSON.stringify(roles)}`);
    return this.authServiceProv.getCommonRoutines().pipe(
      switchMap( auth => {
        if (auth.isNativeAuthorization()) {
          this.logger.log(`[RoleGuard] allow native auth url=${state.url}`);
          return of(true);
        }
        return this.authServiceProv.getAuthDetailsService().pipe(
          switchMap( detailsApi => detailsApi.getUserRole()),
          map( userRole => {
            const hasRole = roles.some( expectedRole => expectedRole === userRole);
            this.logger.log(`[RoleGuard] resolved role=${userRole} hasRole=${hasRole} url=${state.url}`);
            return hasRole;
          }),
          tap( hasRole => {
            if (!hasRole) {
              this.logger.log(`[RoleGuard] deny url=${state.url} -> /forbidden`);
              this.router.navigateByUrl('/forbidden').then();
            }
          })
        )
      }));
  }
}
